/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Account_Notifications_Toast_PausedInputs */

const he_account_notifications_toast_paused = /** @type {(inputs: Account_Notifications_Toast_PausedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ההתראה הושהתה`)
};

const en_account_notifications_toast_paused = /** @type {(inputs: Account_Notifications_Toast_PausedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notification paused`)
};

/**
* | output |
* | --- |
* | "Notification paused" |
*
* @param {Account_Notifications_Toast_PausedInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const account_notifications_toast_paused = /** @type {((inputs?: Account_Notifications_Toast_PausedInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Account_Notifications_Toast_PausedInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_account_notifications_toast_paused(inputs)
	return en_account_notifications_toast_paused(inputs)
});